import * as React from 'react';

import './RolloutEmpty.css';

import { WarningOutlined } from '@duxton-web/icons';
import { Button, Typography } from 'antd';

const { Text } = Typography;

export interface NoRolloutBlockProps {
  enableStartConfigure: (start: boolean) => void;
  isArchived: boolean;
  disableConfigureRollout: boolean;
}

export class RolloutEmpty extends React.Component<NoRolloutBlockProps> {
  handleEnableRolloutEdit = () => {
    this.props.enableStartConfigure(true);
  };

  render() {
    const { isArchived, disableConfigureRollout } = this.props;
    if (isArchived) {
      return (
        <div className="no-rollout-block">
          <br />
          <br />
          This variable is archived <br />
          All values returned from GetVariable call is resolved to{' '}
          <Text code>Code Default</Text>
          <br />
          <WarningOutlined />
          &nbsp; To configure rollout, undo archive from variable page.
        </div>
      );
    }
    return (
      <div className="no-rollout-block">
        <br />
        <br />
        This variable does not have any rollout configured on it. <br />
        All values returned from GetVariable call will be resolved to{' '}
        <Text code>Code Default</Text>, if there is also no experiment running
        on this variable. <br />
        <br />
        <WarningOutlined />
        &nbsp; Configure a new rollout or restore a previous version from the
        History pane on top left.
        <br />
        <br />
        {!disableConfigureRollout && (
          <Button type="primary" onClick={this.handleEnableRolloutEdit}>
            Start Configuring Rollout
          </Button>
        )}
      </div>
    );
  }
}

export default RolloutEmpty;
